// extracted by mini-css-extract-plugin
export default {"tile":"WordButton_tile__wKq3R","selecting":"WordButton_selecting__iYsOy","tileSelect":"WordButton_tileSelect__eE-wF"};